import { Container, Box, Typography, Divider } from '@mui/material'
import { useIntl } from 'react-intl'
import ButtonDownloadSoftware from './Common/ButtonDownloadSoftware'
import { Link } from 'react-router-dom'
import Countdown from './Countdown'

export default function GOLEMTransition() {
  const intl = useIntl()
  const downloadLauncherText = intl.formatMessage({ id: 'userArea.downloadLauncher' })

  return (
    <Box py={8}>
      <Container sx={{ mt: 0, mb: 0, textAlign: 'left', maxWidth: { md: 900 } }}>
        <Typography variant='h2' component='h1'>
          License System Update – Installation Guide
        </Typography>
        <Typography mt={5}>
          On May 31st, we will discontinue MatrixGold’s original license validation system. Many users remain on this
          outdated system due to not updating their software, often because they launch MatrixGold from the desktop icon
          instead of the Gemvision Launcher, where updates are available.
        </Typography>
        <Countdown targetDate='2025-05-31T23:59:59' />
        <Typography mt={5}>
          To ensure you are running the latest version of MatrixGold, please follow the steps below:
        </Typography>
        <Divider />
        <Typography variant='h4'>Step 1: Download the Latest Gemvision Launcher</Typography>
        <ol>
          <li>
            <Typography ml={1}>
              Click the button below to download the most recent version of the <b>Gemvision Launcher</b>.
            </Typography>
          </li>
        </ol>
        <Box mt={2} ml={6}>
          <ButtonDownloadSoftware version='launcher' text={downloadLauncherText} />
        </Box>
        <Divider />
        <Typography variant='h4'>Step 2: Install and Run the Launcher</Typography>
        <ol>
          <li>
            <Typography ml={1}>
              <b>Install</b> the downloaded Gemvision Launcher.
            </Typography>
          </li>
          <li>
            <Typography ml={1}>
              <b>Open</b> the Launcher after installation.
            </Typography>
          </li>
          <li>
            <Typography ml={1}>Proceed to the next step.</Typography>
          </li>
        </ol>
        <Divider />
        <Typography variant='h4'>Step 3: Log In to Your Account</Typography>
        <ol>
          <li>
            <Typography ml={1}>
              Enter your Stuller credentials and click <b>Log In</b>.
            </Typography>
          </li>
        </ol>
        <Box
          component='img'
          alt='Gemvision Launcher login screen.'
          src='https://meteor.stullercloud.com/das/143457607?fmt=smart-alpha&wid=1200'
          sx={{ width: '100%', mt: 2 }}
        />
        <Divider />
        <Typography variant='h4'>Step 4: Automatic Update Download</Typography>
        <ol>
          <li>
            <Typography ml={1}>
              Once logged in, the latest MatrixGold version you own will begin downloading automatically.
            </Typography>
          </li>
          <li>
            <Typography ml={1}>Please wait for the download to complete.</Typography>
          </li>
        </ol>
        <Box
          component='img'
          src='https://meteor.stullercloud.com/das/143457611?fmt=smart-alpha&wid=1200'
          sx={{ width: '100%', mt: 2 }}
        />
        <Divider />
        <Typography variant='h4'>Step 5: Install the Update</Typography>
        <ol>
          <li>
            <Typography ml={1}>
              After the download is complete, click the <b>arrow button</b> in the menu.
            </Typography>
          </li>
          <li>
            <Typography ml={1}>
              Click <b>Update Now</b> to begin the installation.
            </Typography>
          </li>
        </ol>
        <Box
          component='img'
          src='https://meteor.stullercloud.com/das/143457618?fmt=smart-alpha&wid=1200'
          sx={{ width: '100%', mt: 2 }}
        />
        <Divider />
        <Typography variant='h4'>Step 6: Complete the Installation</Typography>
        <ol>
          <li>
            <Typography ml={1}>Follow the standard installation process for MatrixGold.</Typography>
          </li>
        </ol>
        <Box
          component='img'
          src='https://meteor.stullercloud.com/das/143569495?fmt=smart-alpha&wid=1200'
          sx={{ width: '100%', mt: 2 }}
        />
        <Divider />
        <Typography variant='h4'>Final Step: Verify the Installation</Typography>
        <ol>
          <li>
            <Typography ml={1}>
              Once installed, the <b>Launch</b> button in the Gemvision Launcher should appear without a notification
              mark.
            </Typography>
          </li>
          <li>
            <Typography ml={1}>
              <b>Congratulations!</b> You are now ready to use the latest version of MatrixGold.
            </Typography>
          </li>
        </ol>
        <Box
          component='img'
          src='https://meteor.stullercloud.com/das/143457619?fmt=smart-alpha&wid=1200'
          sx={{ width: '100%', mt: 2 }}
        />
        <Divider />
        <Typography variant='h4'>Need Assistance?</Typography>
        <Typography mt={3}>
          If you experience any issues during the download or installation process, please reach out to our{' '}
          <Link to='/tech-support'>Technical Support</Link> team for assistance.
        </Typography>
        <Typography mt={2}>
          We appreciate your cooperation and look forward to providing you with an improved experience.
        </Typography>
      </Container>
    </Box>
  )
}
